import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f8b0eea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column-reverse flex-lg-row align-items-center justify-content-center justify-content-lg-between px-md-5" }
const _hoisted_2 = { class: "fs-8" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between mb-2 mb-lg-0" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["data-bs-toggle", "data-bs-target", "onClick"]

import { ref } from 'vue'
import { useAuthenticated } from '@/use/authentication'
import { useRoute } from 'vue-router'
import { URL_PRIVACY, URL_COMPANY, URL_CUSTOMER, URL_SUPPORT } from '@/constants/common'
import { translate } from '@/languages/i18n'
import { PropType } from 'vue'
import { INQUIRY_STORE } from '@/store/constants'
import { useStore } from 'vuex'

type FooterLink = {
  id: number
  title: string
  to: string
  dataBsTarget: any
  dataBsToggle: any
  onClick: any
}


export default /*#__PURE__*/_defineComponent({
  props: {
  ShowMembership: {
    type: Function as PropType<() => void | undefined>,
  },
  ShowMembershipAlumni: {
    type: Function as PropType<() => void | undefined>,
  },
},
  setup(__props) {

const props = __props

const { authenticated } = useAuthenticated()

const store = useStore()

const route = useRoute()


const resetForm = () => {
  store.dispatch(INQUIRY_STORE.ACTIONS.SET_INQUIRY_DATA, { inquiry_type: '1', content: '', file1: '', file2: '', file3: '', email: '' })
}

const menu: ref<Array<FooterLink>> = [
  {
    id: 2,
    title: translate('privacy'),
    to: URL_PRIVACY,
  },
  {
    id: 3,
    title: translate('company'),
    to: URL_COMPANY,
  },
]

const menuAfterLogin: Array<FooterLink> = [
  {
    id: 1,
    title: translate('membership'),
    to: 'open_modal',
    dataBsTarget: '#membership',

    dataBsToggle: 'modal',
    onClick: props.ShowMembershipAlumni,
  },
  {
    id: 2,
    title: translate('privacy'),
    to: URL_PRIVACY,
  },
  {
    id: 3,
    title: translate('inquiry2'),
    to: URL_SUPPORT,
  },
  {
    id: 4,
    title: translate('company'),
    to: URL_COMPANY,
  },
]

const menuChooseCommunity: Array<FooterLink> = [
  {
    id: 0,
    title: translate('notes'),
    to: 'open_modal',
    dataBsTarget: '#membership',
    dataBsToggle: 'modal',
    onClick: props.ShowMembership,
  },
  {
    id: 1,
    title: translate('membership'),
    to: 'open_modal',
    dataBsTarget: '#membership',
    dataBsToggle: 'modal',
    onClick: props.ShowMembershipAlumni,
  },
  {
    id: 2,
    title: translate('privacy'),
    to: URL_PRIVACY,
  },
  {
    id: 3,
    title: translate('inquiry2'),
    to: URL_SUPPORT,
  },
  {
    id: 4,
    title: translate('company'),
    to: URL_COMPANY,
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(translate)('copyRight')), 1),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(authenticated) ? (_unref(route).path.split('/')[2] === 'communities' && _unref(route).params?.id ? menuChooseCommunity : menuAfterLogin) : menu, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id
        }, [
          (item.to !== 'open_modal')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: item.to,
                class: "text-black text-decoration-none fs-8",
                target: "_blank"
              }, _toDisplayString(item.title), 9, _hoisted_4))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "text-black text-decoration-none fs-8 cursor-pointer",
                "data-bs-toggle": item.dataBsToggle,
                "data-bs-target": item.dataBsTarget,
                onClick: item.onClick
              }, _toDisplayString(item.title), 9, _hoisted_5))
        ]))
      }), 128))
    ])
  ]))
}
}

})